// removed by extract-text-webpack-plugin
module.exports = {"slickslider":"_3bbSmlfAPP_VvaeWv2MzIf","itemWrap":"_3AnlvKtdhTQnsLZd-vd5zV","next":"_3yo-rWgzvUF6wbyL7VP9Mj","prev":"_1un49t8tOHphPgUVbe2ZoF","white":"_1fxJhKcd9SL4Dk1nyZV9VU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/third-party/SlickCarousel/style.css
// module id = 265
// module chunks = 42